import { medtechApiClient } from './axios';
import { Company } from '../types/company';

export const companyApi = {
  async fetchCompany(companyId: number): Promise<Company> {
    return (await medtechApiClient.get<Company>(`/v2/${companyId}/company`)).data;
  },
};
